// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"897d5e8f","111":"0c6348fe","144":"c8e67b0f","193":"959549e4","371":"587e33dc","538":"697e3970","787":"07786814","911":"0d47db79","983":"d30e49e8"}[chunkId] + ".chunk.js";
};